import { fractionsTheme } from './fractions/config';

export const themes = {
  fractions: fractionsTheme,
  // Тут будуть інші теми: multiplication, division, etc.
};

export const getTheme = (themeId) => {
  return themes[themeId];
};